import React, { useState } from "react";
import CommentsList from "@components/comments/CommentsList";
import HistoryList from "@components/histroy/HistroyList";
import WorkLogShort from "@plugin/worklog/views/workLogShort";
import TabSwitcher from "@components/TabSwitcher"; // adjust import path
const CommentsHistory = ({ showWorkLog=true,record_type, recordId }) => {
  const [defaultView, setDefaultView] = useState("comments");

  const tabs = [
    { key: "comments", label: "Comments" },
    { key: "history", label: "History" },
    ...(showWorkLog ? [{ key: "worklog", label: "Work Log" }] : []),
  ];
  return (
    <div className="p-1 mt-2">
      <TabSwitcher tabs={tabs} activeTab={defaultView} onTabChange={setDefaultView} />
      <div className="mt-4">
        {defaultView === "comments" && (
          <CommentsList record_type={record_type} record_id={recordId} />
        )}
        {defaultView === "history" && (
          <HistoryList record_type={record_type} record_id={recordId} />
        )}
         {defaultView === "worklog"  && showWorkLog && (
          <WorkLogShort record_id={recordId} />
        )}
      </div>
    </div>
  );
};
export default CommentsHistory;